/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ITreatmentDeliveryPlan } from 'app/shared/model/treatment-delivery-plan.model';
import { ITreatmentCycle } from 'app/shared/model/treatment-cycle.model';
import { IClinicalDictionary } from 'app/shared/model/clinical-dictionary.model';
import { ITreatmentRegimen } from 'app/shared/model/treatment-regimen.model';

export interface ITreatmentAdverseEvent {
  id?: string;
  eventDate?: number | null;
  eventDescription?: string | null;
  severity?: string | null;
  impactedParameters?: string | null;
  mitigationStrategiesTaken?: string | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  plan?: ITreatmentDeliveryPlan | null;
  cycles?: ITreatmentCycle | null;
  eventType?: IClinicalDictionary | null;
  eventResult?: IClinicalDictionary | null;
  regimen?: ITreatmentRegimen | null;
}

export const defaultValue: Readonly<ITreatmentAdverseEvent> = {
  active: false,
};
